import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import fatcaQuestionnaireType from '../../../life-config/fatcaQuestionConfig.json';
import lifeProductType from '../../../life-config/productCodeConfig.json';
import apiUrlPoint from '../../../life-config/apiEndPoints.json';
import { ApiService } from '../../../services/api.service';
import { map, startWith } from 'rxjs/operators';
import { SharedApiService } from '../../../services/shared-api.service';
import { CountryInfo } from '../../../model/data.model';
import trackingInfo from '../../../life-config/journey-tracker.json';


@Component({
  selector: 'app-covid-question',
  templateUrl: './covid-question.component.html',
  styleUrls: ['./covid-question.component.css']
})
export class CovidQuestionComponent implements OnInit {

  questionnaireForm: FormGroup;
  fatcaQuestionnaireDetails: object = fatcaQuestionnaireType.FatcaQuestionnaireFormInitialJson;
  covidQuestionnaireDetails: object = fatcaQuestionnaireType.covidQuestion;
  defenceQuestionnaireDetails: object = fatcaQuestionnaireType.defenceQuestion;
  occupationQuestionnaireDetails: object = fatcaQuestionnaireType.occupationQuestion;
  apiUrl: object = apiUrlPoint.apiEndPoints;
  trackInfo: object = trackingInfo['tracker-info'];
  birthCountryList: any;
  citizenCountryList: any;
  companyList: any;
  addressCountryList: any;
  taxResidencyCountry: any;
  addressStateList: any;
  addResidencyState: any;
  addressCityList: any;
  addressPincode: any;
  mergedCovidData: any;
  defenceData: any;
  occupdationData: any;
  proposalRes: any;
  fatcaData: any;
  finalDataToSend: any;
  tabListData: any;
  covidDelaration = false;
  // residence_tax : any;

  uuid: string;
  proposalId: string;
  productType: object = lifeProductType.product_type;
  dateArrivedMinDate: any;
  dateDepartedMaxDate: any;
  isLeftSectionLoader = false;
  isLoaderActivated = false;
  testedMaxDate: any;
  testedMinDate: any;
  constructor(

    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private sharedData: SharedApiService,
    private formbuild: FormBuilder
  ) {

    this.apiService.getStatusEvent.subscribe(value => {

        if (value) {
            const errorStatusFromApi = value['status'];

            if ( errorStatusFromApi === 400 ) {

                this.isLoaderActivated = false;
            }
        }


    });

    this.questionnaireForm = this.formbuild.group({

        /**
         * Covid -19
         */
        parentFirstQuestion: [this.covidQuestionnaireDetails['parentFirstQuestion']['default']],
        covidSymptoms: [this.covidQuestionnaireDetails['covidSymptoms']['default']],
        resideInIndiaWithNoPlans: [this.covidQuestionnaireDetails['thirdParentQuestion']['default']],
        inTouchWithCovid: [this.covidQuestionnaireDetails['inTouchWithCovid']['default']],
        inTouchWithCovidDesc : [],
        imposedByAuth: [this.covidQuestionnaireDetails['imposedByAuth']['default']],
        imposedByAuthDesc: [],
        awaitResultCovid: [this.covidQuestionnaireDetails['awaitResult']['default']],
        testedPositive: [this.covidQuestionnaireDetails['testedPositive']['default']],
        covidTestPositiveDate: [],
        covidSymptomsDesc: [],
        residingOutsideIndia: [this.covidQuestionnaireDetails['residingOutside']['default']],
        residingOutsideCountry: [],
        residingOutsideCity: [],
        residingTravelDate: [],
        residingTravelIntendedDuration : [],
        travelOutsideIndia: [this.covidQuestionnaireDetails['travelOutside']['default']],
        travelOutsideCountry: [],
        travelOutsideCity: [],
        dateArrived: [],
        dateDeparted: [],
        travelIntentionOutside : [this.covidQuestionnaireDetails['travelOutside']['default']],
        travelIntentionOutsideCountry: [],
        travelIntentionOutsideCity: [],
        travelIntentionOutsideDateArrived: [],
        travelIntentionIntentDuration: [],
        disbaledCovidSymptoms: [false],
        covidPositivetestDetail: [],
        acceptFirstDeclaration: [false],
        acceptSecondDeclaration: [false],

        /**
         * this is for 3rd question when it has been selected as no
         */

        residingOutsideIndiaOnNo: [this.covidQuestionnaireDetails['residingOutside']['default']],
        residingOutsideCountryOnNO: [''],
        residingOutsideCityOnNo: [''],
        residingTravelDateOnNo: [''],
        residingTravelIntendedDurationOnNo: [''],

        travelOutsideIndiaOnNo: [this.covidQuestionnaireDetails['travelOutside']['default']],
        travelOutsideCountryOnNO: [''],
        travelOutsideCityOnNo: [''],
        dateArrivedOnNo: [''],
        dateDepartedOnNo: [''],

        travelIntentionOutsideOnNo: [this.covidQuestionnaireDetails['travelOutside']['default']],
        travelIntentionOutsideCountryOnNO: [''],
        travelIntentionOutsideCityOnNo: [''],
        travelIntentionOutsideDateArrivedOnNo: [''],
        travelIntentionIntentDurationOnNo: ['']




        });


    this.sharedData.tabEventData.subscribe(value => {
            if (value) {

                this.tabListData = value;


            }
        });

    this.dateArrivedMinDate = new Date();
    this.dateDepartedMaxDate = new Date();
    this.testedMaxDate = new Date();

    this.testedMinDate = new Date('12-01-2019');

    }


    feedProposalData() {

        /**
         * get Tab data
         */

        this.tabListData = this.sharedData.storeTabInfo();


        /**
         * set data as per conditional
         */


        // covid_diagnosed: this.questionnaireForm.get('parentFirstQuestion').value,
        // covid_symptoms: this.questionnaireForm.get('covidSymptoms').value,
        // travel_plan: this.questionnaireForm.get('resideInIndiaWithNoPlans').value,
        if ( this.proposalRes['questions']['covid_diagnosed']) {

            this.questionnaireForm.patchValue({parentFirstQuestion :  this.proposalRes['questions']['covid_diagnosed']});
        }

        if (  this.proposalRes['questions']['covid_symptoms']) {

            this.questionnaireForm.patchValue({covidSymptoms :  this.proposalRes['questions']['covid_symptoms']});
        }

        if ( typeof this.proposalRes['questions']['travel_plan'] !== 'string' &&  !this.proposalRes['questions']['travel_plan']) {

            this.questionnaireForm.patchValue({resideInIndiaWithNoPlans :  this.proposalRes['questions']['travel_plan']});
        } else {
            this.questionnaireForm.patchValue({resideInIndiaWithNoPlans :  true});
        }



        /**
         * if first and second question is selected yes then
         */

        // if (this.questionnaireForm.get('parentFirstQuestion').value || this.questionnaireForm.get('covidSymptoms').value ) {

        if (this.proposalRes['questions']['covid_close_contact']) {

            this.questionnaireForm.patchValue({ inTouchWithCovid: this.proposalRes['questions']['covid_close_contact'] });
        }


        if (this.proposalRes['questions']['covid_quarantine_noticed']) {

            this.questionnaireForm.patchValue({ imposedByAuth: this.proposalRes['questions']['covid_quarantine_noticed'] });
        }


        if ( this.proposalRes['questions']['covid_tested']) {

            this.questionnaireForm.patchValue({ awaitResultCovid:  this.proposalRes['questions']['covid_tested'] });
        }


        if ( this.proposalRes['questions']['covid_tested_positive'] ) {

            this.questionnaireForm.patchValue({ testedPositive:  this.proposalRes['questions']['covid_tested_positive']  });
        }

        // this.questionnaireForm.patchValue({ imposedByAuth: this.proposalRes['questions']['covid_quarantine_noticed'] });
        // this.questionnaireForm.patchValue({ awaitResultCovid: });
        // this.questionnaireForm.patchValue({ testedPositive: this.proposalRes['questions']['covid_tested_positive'] });

        if (this.questionnaireForm.get('inTouchWithCovid').value) {

                this.questionnaireForm.patchValue({ inTouchWithCovidDesc: this.proposalRes['questions']['covid_diagnosed_detail'] });
            }


        if (this.questionnaireForm.get('imposedByAuth').value) {

                this.questionnaireForm.patchValue({ imposedByAuthDesc: this.proposalRes['questions']['covid_quarantine_detail'] });
            }



        if (this.questionnaireForm.get('testedPositive').value) {

                this.questionnaireForm.patchValue({ covidTestPositiveDate: this.proposalRes['questions']['covid_positive_date'] });
                this.questionnaireForm.patchValue(
                    { covidPositivetestDetail: this.proposalRes['questions']['covid_tested_positive_detail'] }
                );
            }

        if (this.questionnaireForm.get('covidSymptoms').value || this.proposalRes['questions']['covid_symptoms_detail']) {
                this.questionnaireForm.patchValue({disbaledCovidSymptoms : true});
                this.questionnaireForm.patchValue({ covidSymptomsDesc: this.proposalRes['questions']['covid_symptoms_detail'] });
        }

            /**
             * travel dscription
             * Question from 9A - 9B -9C
             */

        if (this.proposalRes['questions']['covid_outside_travel']) {

                 this.questionnaireForm.patchValue({ residingOutsideIndia: this.proposalRes['questions']['covid_outside_travel'] });
                 this.questionnaireForm.patchValue({ residingOutsideIndiaOnNo: this.proposalRes['questions']['covid_outside_travel'] });
        }

        if (this.proposalRes['questions']['covid_travel_abroad']) {
                this.questionnaireForm.patchValue({ travelOutsideIndia: this.proposalRes['questions']['covid_travel_abroad'] });
                this.questionnaireForm.patchValue({ travelOutsideIndiaOnNo: this.proposalRes['questions']['covid_travel_abroad'] });
        }

        if (this.proposalRes['questions']['intend_travel_abroad']) {

                this.questionnaireForm.patchValue({ travelIntentionOutside: this.proposalRes['questions']['intend_travel_abroad'] });
                this.questionnaireForm.patchValue({ travelIntentionOutsideOnNo: this.proposalRes['questions']['intend_travel_abroad'] });

        }





        if (this.questionnaireForm.get('residingOutsideIndia').value) {

                this.questionnaireForm.patchValue({ residingOutsideCountry: this.proposalRes['questions']['residing_country'] });
                this.questionnaireForm.patchValue({ residingOutsideCity: this.proposalRes['questions']['residing_city'] });
                this.questionnaireForm.patchValue({ residingTravelDate: this.proposalRes['questions']['covid_travel_date'] });
                this.questionnaireForm.patchValue({ residingTravelIntendedDuration: this.proposalRes['questions']['intended_duration'] });

            }


        if (this.questionnaireForm.get('travelOutsideIndia').value) {

                this.questionnaireForm.patchValue({ travelOutsideCountry: this.proposalRes['questions']['travel_abroad_country'] });
                this.questionnaireForm.patchValue({ travelOutsideCity: this.proposalRes['questions']['travel_abroad_city'] });
                this.questionnaireForm.patchValue({ dateArrived: this.proposalRes['questions']['travel_abroad_date_arrived'] });
                this.questionnaireForm.patchValue({ dateDeparted: this.proposalRes['questions']['travel_abroad_date_departed'] });

            }


        if (this.questionnaireForm.get('travelIntentionOutside').value) {

                this.questionnaireForm.patchValue({ travelIntentionOutsideCountry: this.proposalRes['questions']['intended_country'] });
                this.questionnaireForm.patchValue({ travelIntentionOutsideCity: this.proposalRes['questions']['intended_city'] });
                this.questionnaireForm.patchValue(
                    { travelIntentionOutsideDateArrived: this.proposalRes['questions']['intended_travel_date'] });
                this.questionnaireForm.patchValue({ travelIntentionIntentDuration: this.proposalRes['questions']['intended_duration'] });

        }


        if (!this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {


            this.questionnaireForm.patchValue({ residingOutsideIndiaOnNo:this.proposalRes['questions']['covid_outside_travel'] });
            this.questionnaireForm.patchValue({ travelOutsideIndiaOnNo: this.proposalRes['questions']['covid_travel_abroad'] });
            this.questionnaireForm.patchValue({ travelIntentionOutsideOnNo: this.proposalRes['questions']['intend_travel_abroad'] });



            if (this.questionnaireForm.get('residingOutsideIndiaOnNo').value) {

                this.questionnaireForm.patchValue({ residingOutsideCountryOnNO: this.proposalRes['questions']['residing_country'] });
                this.questionnaireForm.patchValue({ residingOutsideCityOnNo: this.proposalRes['questions']['residing_city'] });
                this.questionnaireForm.patchValue({ residingTravelDateOnNo: this.proposalRes['questions']['covid_travel_date'] });
                this.questionnaireForm.patchValue({ residingTravelIntendedDurationOnNo: this.proposalRes['questions']['intended_duration'] });

            }


            if (this.questionnaireForm.get('travelOutsideIndiaOnNo').value) {

                this.questionnaireForm.patchValue({ travelOutsideCountryOnNO: this.proposalRes['questions']['travel_abroad_country'] });
                this.questionnaireForm.patchValue({ travelOutsideCityOnNo: this.proposalRes['questions']['travel_abroad_city'] });
                this.questionnaireForm.patchValue({ dateArrivedOnNo: this.proposalRes['questions']['travel_abroad_date_arrived'] });
                this.questionnaireForm.patchValue({ dateDepartedOnNo: this.proposalRes['questions']['travel_abroad_date_departed'] });

            }


            if (this.questionnaireForm.get('travelIntentionOutsideOnNo').value) {

                this.questionnaireForm.patchValue({ travelIntentionOutsideCountryOnNO: this.proposalRes['questions']['intended_country'] });
                this.questionnaireForm.patchValue({ travelIntentionOutsideCityOnNo: this.proposalRes['questions']['intended_city'] });
                this.questionnaireForm.patchValue(
                    { travelIntentionOutsideDateArrivedOnNo: this.proposalRes['questions']['intended_travel_date'] });
                this.questionnaireForm.patchValue({ travelIntentionIntentDurationOnNo: this.proposalRes['questions']['intended_duration'] });

            }

        }

        // }




        this.isLeftSectionLoader = false;


    }

    inTouchWithCovidValidation() {

        // Smoke
        const inTouchWithCovidInfo = this.questionnaireForm.get('inTouchWithCovidDesc');
        this.questionnaireForm.get('inTouchWithCovid').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                /**
                 * check for parent information if avail in sys
                 */

                if ((this.questionnaireForm.get('parentFirstQuestion').value ||
                this.questionnaireForm.get('covidSymptoms').value) &&
                this.questionnaireForm.get('resideInIndiaWithNoPlans').value ||
                !this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {

                    if (weightGainMode === true) {


                        inTouchWithCovidInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(260),  Validators.pattern(new RegExp('^[a-zA-Z0-9 ,./:()\\\'`-]+$'))]
                        );
                    }
                    if (weightGainMode === false) {

                        inTouchWithCovidInfo.setValidators(null);

                    }
                } else {
                    inTouchWithCovidInfo.setValidators(null);
                }

                inTouchWithCovidInfo.updateValueAndValidity();

            });
    }

    impousedByAuthorityValidation() {

        // Smoke
        const imposedByAuthority = this.questionnaireForm.get('imposedByAuthDesc');
        this.questionnaireForm.get('imposedByAuth').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if ((this.questionnaireForm.get('parentFirstQuestion').value ||
                this.questionnaireForm.get('covidSymptoms').value) &&
                this.questionnaireForm.get('resideInIndiaWithNoPlans').value ||
                !this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {

                    if (weightGainMode === true) {


                        imposedByAuthority.setValidators(
                            // tslint:disable-next-line: max-line-length
                            // tslint:disable-next-line: quotemark
                            [ Validators.required,
                             Validators.minLength(1),
                             Validators.maxLength(260),  Validators.pattern(new RegExp('^[a-zA-Z0-9 ,./:()\\\'`-]+$'))]
                        );
                    }
                    if (weightGainMode === false) {

                        imposedByAuthority.setValidators(null);

                    }
                } else {

                    imposedByAuthority.setValidators(null);
                }


                imposedByAuthority.updateValueAndValidity();

            });
    }

    testedPositiveValidation() {


        const covidTestedPositiveInfo = this.questionnaireForm.get('covidTestPositiveDate');
        const covidPositivetestInfo = this.questionnaireForm.get('covidPositivetestDetail');
        this.questionnaireForm.get('testedPositive').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if ((this.questionnaireForm.get('parentFirstQuestion').value ||
                this.questionnaireForm.get('covidSymptoms').value) &&
                this.questionnaireForm.get('resideInIndiaWithNoPlans').value ||
                !this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {



                    if (weightGainMode === true) {


                        covidTestedPositiveInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        covidPositivetestInfo.setValidators([Validators.required, Validators.maxLength(250)]);
                    }
                    if (weightGainMode === false) {

                        covidTestedPositiveInfo.setValidators(null);
                        covidPositivetestInfo.setValidators(null);

                    }

                } else {

                    covidTestedPositiveInfo.setValidators(null);
                    covidPositivetestInfo.setValidators(null);
                }


                covidTestedPositiveInfo.updateValueAndValidity();
                covidPositivetestInfo.updateValueAndValidity();

        });
    }

    covidSymptomsValidation() {


        const covidTestedPositiveInfo = this.questionnaireForm.get('covidSymptomsDesc');
        this.questionnaireForm.get('covidSymptoms').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if ((this.questionnaireForm.get('parentFirstQuestion').value ||
                this.questionnaireForm.get('covidSymptoms').value) &&
                this.questionnaireForm.get('resideInIndiaWithNoPlans').value ||
                !this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {

                    if (weightGainMode === true) {


                        covidTestedPositiveInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            // tslint:disable-next-line: quotemark
                            [ Validators.required,
                                Validators.minLength(1), Validators.maxLength(260),
                                Validators.pattern(new RegExp('^[a-zA-Z0-9 ,./:()\\\'`-]+$'))]
                        );
                    }
                    if (weightGainMode === false) {

                        covidTestedPositiveInfo.setValidators(null);

                    }

                } else {

                    covidTestedPositiveInfo.setValidators(null);

                }

                covidTestedPositiveInfo.updateValueAndValidity();

        });
    }

    resideOutsideValidation() {

        const resideCountry = this.questionnaireForm.get('residingOutsideCountry');
        const resideOutsideCity = this.questionnaireForm.get('residingOutsideCity');
        const residetravelDateInfo = this.questionnaireForm.get('residingTravelDate');
        const resideTravelIntentInfo = this.questionnaireForm.get('residingTravelIntendedDuration');
        this.questionnaireForm.get('travelOutsideIndia').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if ((this.questionnaireForm.get('parentFirstQuestion').value ||
                this.questionnaireForm.get('covidSymptoms').value) &&
                this.questionnaireForm.get('resideInIndiaWithNoPlans').value ||
                !this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {

                    if (weightGainMode) {

                        resideCountry.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideOutsideCity.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(25)]
                        );
                        residetravelDateInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(250)]
                        );
                        resideTravelIntentInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                    }
                    if (!weightGainMode) {

                        resideCountry.setValidators(null);
                        resideOutsideCity.setValidators(null);
                        residetravelDateInfo.setValidators(null);
                        resideTravelIntentInfo.setValidators(null);

                    }
                } else {


                    resideCountry.setValidators(null);
                    resideOutsideCity.setValidators(null);
                    residetravelDateInfo.setValidators(null);
                    resideTravelIntentInfo.setValidators(null);
                }


                resideCountry.updateValueAndValidity();
                resideOutsideCity.updateValueAndValidity();
                residetravelDateInfo.updateValueAndValidity();
                resideTravelIntentInfo.updateValueAndValidity();

        });
    }

    travelOutsideValidation() {

        const resideCountry = this.questionnaireForm.get('travelOutsideCountry');
        const resideOutsideCity = this.questionnaireForm.get('travelOutsideCity');
        const residetravelDateInfo = this.questionnaireForm.get('dateArrived');
        const resideTravelIntentInfo = this.questionnaireForm.get('dateDeparted');

        this.questionnaireForm.get('travelOutsideIndia').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if ((this.questionnaireForm.get('parentFirstQuestion').value ||
                this.questionnaireForm.get('covidSymptoms').value) &&
                this.questionnaireForm.get('resideInIndiaWithNoPlans').value ||
                !this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {

                    if (weightGainMode) {

                        resideCountry.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideOutsideCity.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(260)]
                        );
                        residetravelDateInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideTravelIntentInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                    }
                    if (!weightGainMode) {

                        resideCountry.setValidators(null);
                        resideOutsideCity.setValidators(null);
                        residetravelDateInfo.setValidators(null);
                        resideTravelIntentInfo.setValidators(null);
                    }

                } else {

                    resideCountry.setValidators(null);
                    resideOutsideCity.setValidators(null);
                    residetravelDateInfo.setValidators(null);
                    resideTravelIntentInfo.setValidators(null);
                }

                resideCountry.updateValueAndValidity();
                resideOutsideCity.updateValueAndValidity();
                residetravelDateInfo.updateValueAndValidity();
                resideTravelIntentInfo.updateValueAndValidity();

        });
    }

    travelIntentionValidation() {


        const resideCountry = this.questionnaireForm.get('travelIntentionOutsideCountry');
        const resideOutsideCity = this.questionnaireForm.get('travelIntentionOutsideCity');
        const residetravelDateInfo = this.questionnaireForm.get('travelIntentionOutsideDateArrived');
        const resideTravelIntentInfo = this.questionnaireForm.get('travelIntentionIntentDuration');
        this.questionnaireForm.get('travelIntentionOutside').valueChanges.subscribe(
            (weightGainMode: boolean) => {

                if ((this.questionnaireForm.get('parentFirstQuestion').value ||
                this.questionnaireForm.get('covidSymptoms').value) &&
                this.questionnaireForm.get('resideInIndiaWithNoPlans').value ||
                !this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {

                    if (weightGainMode) {

                        resideCountry.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideOutsideCity.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(25)]
                        );
                        residetravelDateInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideTravelIntentInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(250)]
                        );
                    }
                    if (!weightGainMode) {

                        resideCountry.setValidators(null);
                        resideOutsideCity.setValidators(null);
                        residetravelDateInfo.setValidators(null);
                        resideTravelIntentInfo.setValidators(null);

                    }
                } else {
                    resideCountry.setValidators(null);
                    resideOutsideCity.setValidators(null);
                    residetravelDateInfo.setValidators(null);
                    resideTravelIntentInfo.setValidators(null);
                }

                resideCountry.updateValueAndValidity();
                resideOutsideCity.updateValueAndValidity();
                residetravelDateInfo.updateValueAndValidity();
                resideTravelIntentInfo.updateValueAndValidity();

        });
    }


    /**
     * on no validation
     */

    resideOutsideValidationOnNo() {

        const resideCountry = this.questionnaireForm.get('residingOutsideCountryOnNO');
        const resideOutsideCity = this.questionnaireForm.get('residingOutsideCityOnNo');
        const residetravelDateInfo = this.questionnaireForm.get('residingTravelDateOnNo');
        const resideTravelIntentInfo = this.questionnaireForm.get('residingTravelIntendedDurationOnNo');
        this.questionnaireForm.get('residingOutsideIndiaOnNo').valueChanges.subscribe(
            (weightGainMode: boolean) => {


                    if (weightGainMode) {

                        resideCountry.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideOutsideCity.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(25)]
                        );
                        residetravelDateInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideTravelIntentInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(250)]
                        );
                    }
                    if (!weightGainMode) {

                        resideCountry.setValidators(null);
                        resideOutsideCity.setValidators(null);
                        residetravelDateInfo.setValidators(null);
                        resideTravelIntentInfo.setValidators(null);

                    }



                    resideCountry.updateValueAndValidity();
                    resideOutsideCity.updateValueAndValidity();
                    residetravelDateInfo.updateValueAndValidity();
                    resideTravelIntentInfo.updateValueAndValidity();

        });
    }

    travelOutsideValidationOnNo() {

        const resideCountry = this.questionnaireForm.get('travelOutsideCountryOnNO');
        const resideOutsideCity = this.questionnaireForm.get('travelOutsideCityOnNo');
        const residetravelDateInfo = this.questionnaireForm.get('dateArrivedOnNo');
        const resideTravelIntentInfo = this.questionnaireForm.get('dateDepartedOnNo');

        this.questionnaireForm.get('travelOutsideIndiaOnNo').valueChanges.subscribe(
            (weightGainMode: boolean) => {



                    if (weightGainMode) {

                        resideCountry.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideOutsideCity.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(25)]
                        );
                        residetravelDateInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideTravelIntentInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                    }
                    if (!weightGainMode) {

                        resideCountry.setValidators(null);
                        resideOutsideCity.setValidators(null);
                        residetravelDateInfo.setValidators(null);
                        resideTravelIntentInfo.setValidators(null);
                    }



                    resideCountry.updateValueAndValidity();
                    resideOutsideCity.updateValueAndValidity();
                    residetravelDateInfo.updateValueAndValidity();
                    resideTravelIntentInfo.updateValueAndValidity();

        });
    }


    travelIntentionValidationOnNo() {


        const resideCountry = this.questionnaireForm.get('travelIntentionOutsideCountryOnNO');
        const resideOutsideCity = this.questionnaireForm.get('travelIntentionOutsideCityOnNo');
        const residetravelDateInfo = this.questionnaireForm.get('travelIntentionOutsideDateArrivedOnNo');
        const resideTravelIntentInfo = this.questionnaireForm.get('travelIntentionIntentDurationOnNo');
        this.questionnaireForm.get('travelIntentionOutsideOnNo').valueChanges.subscribe(
            (weightGainMode: boolean) => {



                    if (weightGainMode) {

                        resideCountry.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideOutsideCity.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(25)]
                        );
                        residetravelDateInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required]
                        );
                        resideTravelIntentInfo.setValidators(
                            // tslint:disable-next-line: max-line-length
                            [Validators.required, Validators.minLength(1), Validators.maxLength(250)]
                        );
                    }
                    if (!weightGainMode) {

                        resideCountry.setValidators(null);
                        resideOutsideCity.setValidators(null);
                        residetravelDateInfo.setValidators(null);
                        resideTravelIntentInfo.setValidators(null);

                    }


                    resideCountry.updateValueAndValidity();
                    resideOutsideCity.updateValueAndValidity();
                    residetravelDateInfo.updateValueAndValidity();
                    resideTravelIntentInfo.updateValueAndValidity();

        });
    }

    covidSymptomsDisbaleEvnt() {

        if (this.questionnaireForm.get('covidSymptoms').value) {
            this.questionnaireForm.patchValue({disbaledCovidSymptoms : true});
            this.questionnaireForm.get('disbaledCovidSymptoms').disable();

        } else {
            this.questionnaireForm.patchValue({disbaledCovidSymptoms : false});
            this.questionnaireForm.get('disbaledCovidSymptoms').enable();
        }

    }




    getCountryList() {
        this.apiService.getUtilsInfoWithoutInsurerQuery(this.apiUrl['getUtilsInfo'], this.apiUrl['country']).subscribe(res => {

            this.birthCountryList = res['country'];
            this.citizenCountryList = res['country'];
            this.addressCountryList = res['country'];
            this.taxResidencyCountry = res['country'];


        });
    }

    /**
     * County display
     */

    travelInentionCountry(user?: CountryInfo): any | undefined {

        if (user) {
            return user ? user.master_name : undefined;
        }


    }

    travelOutsideCountry(user?: CountryInfo): any | undefined {

        if (user) {
            return user ? user.master_name : undefined;
        }


    }

    countryResidenceDisplay(user?: CountryInfo): any | undefined {

        if (user) {
            return user ? user.master_name : undefined;
        }


    }

    saveQuestioniarieFormData(isValid: boolean, event) {
        if (isValid) {

            this.isLoaderActivated = true;

            const covidData = {

                covid_diagnosed: this.questionnaireForm.get('parentFirstQuestion').value,
                covid_symptoms: this.questionnaireForm.get('covidSymptoms').value,
                travel_plan: this.questionnaireForm.get('resideInIndiaWithNoPlans').value,


            };



            this.mergedCovidData = covidData;

            /**
             * case 1 :- when user select first question or second question
             */


            if ((this.questionnaireForm.get('parentFirstQuestion').value ||
                this.questionnaireForm.get('covidSymptoms').value) ) {

                const covidDiag = {
                    covid_close_contact: this.questionnaireForm.get('inTouchWithCovid').value,
                    covid_quarantine_noticed: this.questionnaireForm.get('imposedByAuth').value,
                    covid_tested: this.questionnaireForm.get('awaitResultCovid').value,
                    covid_tested_positive : this.questionnaireForm.get('testedPositive').value,
                    covid_outside_travel: this.questionnaireForm.get('residingOutsideIndia').value,
                    covid_travel_abroad: this.questionnaireForm.get('travelOutsideIndia').value,
                    intend_travel_abroad: this.questionnaireForm.get('travelIntentionOutside').value,
                    covid_sub_symptom: this.questionnaireForm.get('disbaledCovidSymptoms').value,

                };


                this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidDiag);


                if (this.questionnaireForm.get('inTouchWithCovid').value) {


                const covidDiagDesc = {

                    covid_diagnosed_detail: this.questionnaireForm.get('inTouchWithCovidDesc').value

                };


                this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidDiagDesc);

                }


                if (this.questionnaireForm.get('imposedByAuth').value) {

                    const covidAuthDesc = {
                        covid_quarantine_detail: this.questionnaireForm.get('imposedByAuthDesc').value

                    };


                    this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidAuthDesc);


                }

                if (this.questionnaireForm.get('testedPositive').value) {

                    const covidTestPositiveDesc = {

                        covid_positive_date:  this.datePipe.transform(new Date(
                            this.questionnaireForm.get('covidTestPositiveDate').value), 'yyyy-MM-dd'),
                            covid_tested_positive_detail: this.questionnaireForm.get('covidPositivetestDetail').value

                    };


                    this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidTestPositiveDesc);


                }

                // if (this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {


                if (this.questionnaireForm.get('residingOutsideIndia').value) {

                        const covidSympDesc = {

                            residing_country: this.questionnaireForm.get('residingOutsideCountry').value,
                            residing_city: this.questionnaireForm.get('residingOutsideCity').value,
                            covid_travel_date: this.datePipe.transform(new Date(
                                this.questionnaireForm.get('residingTravelDate').value ), 'yyyy-MM-dd'),
                            intended_duration:  this.questionnaireForm.get('residingTravelIntendedDuration').value


                        };


                        this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidSympDesc);
                    }

                if (this.questionnaireForm.get('travelOutsideIndia').value) {


                        const covidSympDesc = {

                            travel_abroad_country: this.questionnaireForm.get('travelOutsideCountry').value,
                            travel_abroad_city: this.questionnaireForm.get('travelOutsideCity').value,
                            travel_abroad_date_arrived: this.datePipe.transform(new Date(
                                this.questionnaireForm.get('dateArrived').value ), 'yyyy-MM-dd'),
                            travel_abroad_date_departed:   this.datePipe.transform(new Date(
                                this.questionnaireForm.get('dateDeparted').value ), 'yyyy-MM-dd')


                        };


                        this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidSympDesc);
                    }


                if (this.questionnaireForm.get('travelIntentionOutside').value) {


                        const covidSympDesc = {

                            intended_country: this.questionnaireForm.get('travelIntentionOutsideCountry').value,
                            intended_city: this.questionnaireForm.get('travelIntentionOutsideCity').value,
                            intended_travel_date: this.datePipe.transform(new Date(
                                this.questionnaireForm.get('travelIntentionOutsideDateArrived').value ), 'yyyy-MM-dd'),
                            intended_duration_travel_abroad:  this.questionnaireForm.get('travelIntentionIntentDuration').value

                        };


                        this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidSympDesc);
                    }

                // }

                if (this.questionnaireForm.get('disbaledCovidSymptoms').value) {

                    const covidSympDesc = {

                        covid_symptoms_detail: this.questionnaireForm.get('covidSymptomsDesc').value

                    };


                    this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidSympDesc);


                }

                /**
                 * condiition if parent question and se
                 */

            }



            /**
             * value in case of 3rd question
             */

            if ( !this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {


                const covidDiag = {
                    covid_close_contact: this.questionnaireForm.get('inTouchWithCovid').value,
                    covid_quarantine_noticed: this.questionnaireForm.get('imposedByAuth').value,
                    covid_tested: this.questionnaireForm.get('awaitResultCovid').value,
                    covid_tested_positive : this.questionnaireForm.get('testedPositive').value,
                    covid_outside_travel: this.questionnaireForm.get('residingOutsideIndiaOnNo').value,
                    covid_travel_abroad: this.questionnaireForm.get('travelOutsideIndiaOnNo').value,
                    intend_travel_abroad: this.questionnaireForm.get('travelIntentionOutsideOnNo').value,
                    covid_sub_symptom: this.questionnaireForm.get('disbaledCovidSymptoms').value,

                };


                this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidDiag);


                if (this.questionnaireForm.get('inTouchWithCovid').value) {


                const covidDiagDesc = {

                    covid_diagnosed_detail: this.questionnaireForm.get('inTouchWithCovidDesc').value

                };


                this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidDiagDesc);

                }


                if (this.questionnaireForm.get('imposedByAuth').value) {

                    const covidAuthDesc = {
                        covid_quarantine_detail: this.questionnaireForm.get('imposedByAuthDesc').value

                    };


                    this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidAuthDesc);


                }

                if (this.questionnaireForm.get('testedPositive').value) {

                    const covidTestPositiveDesc = {

                        covid_positive_date:  this.datePipe.transform(new Date(
                            this.questionnaireForm.get('covidTestPositiveDate').value), 'yyyy-MM-dd'),
                            covid_tested_positive_detail: this.questionnaireForm.get('covidPositivetestDetail').value

                    };


                    this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidTestPositiveDesc);


                }

            // if (this.questionnaireForm.get('resideInIndiaWithNoPlans').value) {


                if (this.questionnaireForm.get('residingOutsideIndiaOnNo').value) {

                        const covidSympDesc = {

                            residing_country: this.questionnaireForm.get('residingOutsideCountryOnNO').value,
                            residing_city: this.questionnaireForm.get('residingOutsideCityOnNo').value,
                            covid_travel_date: this.datePipe.transform(new Date(
                                this.questionnaireForm.get('residingTravelDateOnNo').value ), 'yyyy-MM-dd'),
                            intended_duration:  this.questionnaireForm.get('residingTravelIntendedDurationOnNo').value


                        };


                        this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidSympDesc);
                    }

                if (this.questionnaireForm.get('travelOutsideIndiaOnNo').value) {



                        const covidSympDesc = {

                            travel_abroad_country: this.questionnaireForm.get('travelOutsideCountryOnNO').value,
                            travel_abroad_city: this.questionnaireForm.get('travelOutsideCityOnNo').value,
                            travel_abroad_date_arrived: this.datePipe.transform(new Date(
                                this.questionnaireForm.get('dateArrivedOnNo').value ), 'yyyy-MM-dd'),
                            travel_abroad_date_departed: this.datePipe.transform(new Date(
                                this.questionnaireForm.get('dateDepartedOnNo').value ), 'yyyy-MM-dd'),


                        };


                        this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidSympDesc);
                    }


                if (this.questionnaireForm.get('travelIntentionOutsideOnNo').value) {



                        const covidSympDesc = {

                            intended_country: this.questionnaireForm.get('travelIntentionOutsideCountryOnNO').value,
                            intended_city: this.questionnaireForm.get('travelIntentionOutsideCityOnNo').value,
                            intended_travel_date: this.datePipe.transform(new Date(
                                this.questionnaireForm.get('travelIntentionOutsideDateArrivedOnNo').value ), 'yyyy-MM-dd'),
                            intended_duration_travel_abroad:   this.questionnaireForm.get('travelIntentionIntentDurationOnNo').value,


                        };


                        this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidSympDesc);
                    }



                if (this.questionnaireForm.get('disbaledCovidSymptoms').value  ) {

                    const covidSympDesc = {

                        covid_symptoms_detail: this.questionnaireForm.get('covidSymptomsDesc').value

                    };


                    this.mergedCovidData = Object.assign({}, this.mergedCovidData, covidSympDesc);


                }


            }


            const mergedObjectInfoData: any = {

                questions: Object.assign({}, this.mergedCovidData),
                journey_track: this.trackInfo['QUESTIONNAIRE']
            };

            this.finalDataToSend =  Object.assign({}, mergedObjectInfoData);

            /** Invoking api serices -Update proposal */

            this.apiService.updateProposal(
                this.apiUrl['apiV2LifeProposal'],
                this.proposalId, this.uuid,
                this.apiUrl['update_proposal'],
                this.finalDataToSend).subscribe(res => {

                if (res) {
                    this.isLoaderActivated = false;
                    if (this.tabListData && this.tabListData.length > 1) {


                        this.tabListData.forEach((element, index) => {

                            if (element['type'] === 'covid') {

                                if(index < (this.tabListData.length) - 1) {
    
                                    this.sharedData.getNextCrntActiveTab(this.tabListData[index + 1] , 0);
                                } else {
                                    
                                    this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                                }
                            }


                         });




                    } else {

                        this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                    }
                }

            },
                err => {
                    console.log('sonething went at our end', err);
                });

        }
    }

    ngOnInit() {

        this.activatedRoute.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.proposalId = params['proposalId'];
        });

        // Get propsoal info

        if (this.uuid && this.proposalId) {

            this.isLeftSectionLoader = true;
            this.sharedData.getProposalInfo(this.proposalId, this.uuid).subscribe(res => {
                if (res) {

                    this.proposalRes = res;


                    if (this.proposalRes) {

                        this.feedProposalData();

                    }
                }

            });

            this.getCountryList();

            /**
             * Covid -19 validation
             */

            this.inTouchWithCovidValidation();
            this.impousedByAuthorityValidation();
            this.testedPositiveValidation();
            this.covidSymptomsValidation();
            this.travelOutsideValidation();
            this.resideOutsideValidation();
            this.travelIntentionValidation();
            this.resideOutsideValidationOnNo();
            this.travelOutsideValidationOnNo();
            this.travelIntentionValidationOnNo();
        }
    }



    backBtnDetails() {
        this.router.navigate(['/life/upload-document', this.proposalId, this.uuid])
        .then(() => {
            window.location.reload();
        });

      }


    /**
     * Covide delaration
     */

    covidDeclaration() {

        if (this.questionnaireForm.get('acceptFirstDeclaration').value  && this.questionnaireForm.get('acceptSecondDeclaration').value) {

            this.covidDelaration = true;

        } else {
            this.covidDelaration = false;
        }
    }


}
